import styled from 'styled-components';

export const BtnWrapp = styled.div`
  width: 32px;
`;
